<template>
    <div>
        <div class="calendar_box">
            <ul class="week_ul">
                <li class="week_li">
                    <p class="week_p">一</p>
                    <p class="week_p">MON</p>
                </li>
                <li class="week_li">
                    <p class="week_p">二</p>
                    <p class="week_p">TUE</p>
                </li>
                <li class="week_li">
                    <p class="week_p">三</p>
                    <p class="week_p">WED</p>
                </li>
                <li class="week_li">
                    <p class="week_p">四</p>
                    <p class="week_p">THU</p>
                </li>
                <li class="week_li">
                    <p class="week_p">五</p>
                    <p class="week_p">FRI</p>
                </li>
                <li class="week_li">
                    <p class="week_p">六</p>
                    <p class="week_p">SAT</p>
                </li>
                <li class="week_li">
                    <p class="week_p">日</p>
                    <p class="week_p">SUN</p>
                </li>
            </ul>
        </div>
        <div class="date" v-if="closeDateObj">
            <ul class="date_ul">
                <li class="date_li" :class="{'date_act':item.hownumber == todayDate,'no_select':openLaterSeven.indexOf(item.hownumber) == -1 || item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1,'selected_act':selectedDate == item.thisdate}" v-for="(item,index) in firstWeekArr" :key="'up'+index" @click="getThisDate(item.thisdate,item.indexval)">
                    <p class="date_p">{{item.hownumber}}</p>
                    <p class="date_p date_p_text" v-if="item.hownumber == todayDate">{{$t('appointment.today')}}</p>
                    <p class="date_p date_p_text" v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1)  && item.hownumber != todayDate">{{$t('appointment.closed')}}</p>
                    <!--<p class="date_p date_p_text" v-if="item.hownumber !== todayDate && item.indexval !== closeindex && closeDateObj.close_date_list.indexOf(item.thisdate) == -1">可预约</p>-->
                </li>
            </ul>
            <ul class="date_ul">
                <li class="date_li" :class="{'no_select':openLaterSeven.indexOf(item.hownumber) == -1 || item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1,'selected_act':selectedDate == item.thisdate}" v-for="(item,index) in secondWeekArr" :key="'down'+index" @click="getThisDate(item.thisdate,item.indexval)">
                    <p class="date_p">{{item.hownumber}}</p>
                    <p class="date_p date_p_text" v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1)  && item.hownumber != todayDate">{{$t('appointment.closed')}}</p>
                    <!--<p class="date_p date_p_text" v-else>可预约</p>-->
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { getLang } from "../config/language.js";
export default {
    props: {
        closeDateObj: {
            type: Object
            // default: () => {
            //     return {
            //         current_time: new Date().getTime()
            //     };
            // }
        }
    },
    data() {
        return {
            firstWeekArr: [], //第一周
            secondWeekArr: [], //第二周
            todayDate: null,
            closeindex: 0, //星期三闭馆
            //				closeDateObj.close_date_list:['2018-10-31','2018-11-2'],//闭馆日
            openLaterSeven: [], //今天之后的七天才有机会预约
            language: getLang("LOCAL") || 1,
            selectedDate:
                this.$utils.getStore("currentDate") &&
                this.$utils.getStore("currentDate") != "undefined"
                    ? this.$utils.getStore("currentDate")
                    : ""
        };
    },
    mounted() {},
    watch: {
        closeDateObj(newVal, oldVal) {
            this.closeindex = this.closeDateObj.per_week_close_date - 1;
            this.init(this.closeDateObj.current_time * 1000);
        }
    },
    methods: {
        init(current_time) {
            const v = this;
            var everydayInfor = {}; //存放某一天的日期，如：2018-10-27,星期的所引值0~6,以及多少号：如今天是2018-10-27取27
            //				var weekday = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            var todaydate = new Date(current_time); //获取今天的日期
            var todayweekval = todaydate.getDate(); //返回今天是多少号
            v.todayDate = todayweekval;
            var weekindex = todaydate.getDay(); //返回今天是周几的索引值
            everydayInfor = v.getOneDayInforObject(
                v.getOneDayDate(0, current_time),
                weekindex - 1,
                todayweekval
            );
            var todaydatearr = [everydayInfor]; //把今天的日期单独放到一个数组里
            //获取今天之后七天的日期数组
            var sevendayarr = [];
            for (let i = 1; i < 8; i++) {
                var todaydate = new Date(current_time); //获取今天的日期
                todaydate.setDate(todayweekval + i);
                sevendayarr.push(todaydate.getDate());
            }
            v.openLaterSeven = sevendayarr;
            //获取今天之前的星期的日期数组
            var todaybeforearr = [];
            var beforearrnum = weekindex == 0 ? 6 : weekindex - 1; //今天之前的星期有几天
            for (let i = beforearrnum; i > 0; i--) {
                var todaydate = new Date(current_time); //获取今天的日期
                todaydate.setDate(todayweekval - i); //获取今天前i天的日期
                todaybeforearr.push(
                    v.getOneDayInforObject(
                        v.getOneDayDate(-i, current_time),
                        beforearrnum - i,
                        todaydate.getDate()
                    )
                ); //push到日期数组里
            }
            //获取今天之后的星期的日期数组
            var todaylater = [];
            var laterarrnum = weekindex == 0 ? 0 : 7 - weekindex; //获取本周结束剩余的天数
            //				for(let i = 1; i < laterarrnum + 1; i++) {
            //					var todaydate = new Date(current_time); //获取今天的日期
            //					todaydate.setDate(todayweekval + i); //获取今天后i天的日期
            //					todaylater.push(v.getOneDayInforObject(v.getOneDayDate(i,current_time),7-i,todaydate.getDate()));
            //				}
            for (let i = laterarrnum; i > 0; i--) {
                var todaydate = new Date(current_time); //获取今天的日期
                todaydate.setDate(todayweekval + laterarrnum - i + 1); //获取今天后i天的日期
                todaylater.push(
                    v.getOneDayInforObject(
                        v.getOneDayDate(laterarrnum - i + 1, current_time),
                        7 - i,
                        todaydate.getDate()
                    )
                );
            }
            this.firstWeekArr = [
                ...todaybeforearr,
                ...todaydatearr,
                ...todaylater
            ];
            // console.log(this.firstWeekArr);
            //获取本周的下一周日期数组
            var nextweekarr = [];
            for (let i = 1; i < 8; i++) {
                var todaydate = new Date(current_time); //获取今天的日期
                todaydate.setDate(todayweekval + i + laterarrnum);
                nextweekarr.push(
                    v.getOneDayInforObject(
                        v.getOneDayDate(i + laterarrnum, current_time),
                        i - 1,
                        todaydate.getDate()
                    )
                );
            }
            this.secondWeekArr = nextweekarr;
            // console.log(this.secondWeekArr);
        },
        //返回当前日期之前或之后某一天的日期,负值表示之前，正值表示之后
        getOneDayDate(val, current_time) {
            var mydate = new Date(current_time);
            mydate.setDate(mydate.getDate() + val); //获取val天后的日期
            var y = mydate.getFullYear();
            var m = mydate.getMonth() + 1; //获取当前月份的日期
            if (m < 10) {
                m = "0" + m;
            }
            var d = mydate.getDate();
            if (d < 10) {
                d = "0" + d;
            }
            return y + "-" + m + "-" + d;
        },
        //返回日期信息对象
        getOneDayInforObject(date, index, number) {
            var obj = {};
            obj.thisdate = date;
            obj.indexval = index;
            obj.hownumber = number;
            return obj;
        },
        getThisDate(val, val2) {
            var weekday = [
                "周一",
                "周二",
                "周三",
                "周四",
                "周五",
                "周六",
                "周日"
            ];
            this.selectedDate = val;
            this.$emit("currentIndex", val);
            this.$utils.setStore("currentDate", val); //本地存储
            this.$utils.setStore("weekVal", val2);
            // this.$utils.setStore("weekVal", weekday[val2]);
        }
    }
};
</script>
<style lang="scss" scoped>
.calendar_box {
    width: 100%;
    margin: 10px auto;
    .week_ul {
        display: flex;
        justify-content: space-between;
        li.week_li {
            width: 2.8125rem /* 45/16 */;
            height: 2.1875rem /* 35/16 */;
            border-radius: 0.3125rem /* 5/16 */;
            background: #183b58;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .week_p {
                font-size: 0.75rem /* 12/16 */;
                color: #fff;
                text-align: center;
                &:nth-child(2) {
                    font-size: 0.5625rem /* 9/16 */;
                }
            }
        }
    }
}

.date {
    width: 100%;
    min-height: 6.25rem /* 100/16 */;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .date_ul {
        display: flex;
        justify-content: space-between;
        li.date_li {
            width: 2.8125rem /* 45/16 */;
            height: 2.1875rem /* 35/16 */;
            padding: 0.3125rem /* 5/16 */ 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            -webkit-user-select: none;
            user-select: none;
            transition: all 0.2s ease-out 0s;
            .date_p {
                font-size: 0.8125rem /* 13/16 */;
                color: #55555a;
                text-align: center;
            }
            &.selected_act {
                //选择日期
                background: #71cbb2;
                border-radius: 0.3125rem /* 5/16 */;
                position: relative;
                ::after {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 50%;
                    bottom: 0.3125rem /* 5/16 */;
                    width: 0.3125rem /* 5/16 */;
                    height: 0.3125rem /* 5/16 */;
                    transform: translateX(-50%);
                    border-radius: 100%;
                    background: #fff;
                }
                .date_p {
                    color: #fff;
                }
            }
            &.no_select {
                pointer-events: none;
                background-color: #f0f0f0;
                border-radius: 0.3125rem /* 5/16 */;
                .date_p,
                .date_p_text {
                    // 文字
                    color: #c1c1c1;
                }
            }
            &.date_act {
                //当前日期
                width: 2.8125rem /* 45/16 */;
                .date_p_text {
                    font-size: 0.625rem /* 10/16 */;
                    color: #ad011b;
                }
            }
        }
    }
}
</style>